module.exports = __webpack_public_path__ + "static/img/40008 (4).19fcbfc.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40008 (4).webp
// module id = sVVr
// module chunks = 14